// ProxyDeploymentCard: deployment card for proxy connectors — PAC File and Catalog URLs plus MDM file downloads.
import { FC } from 'react';
import { Stack } from '@mui/material';
import Text from '@/components/text';
import TextInput from '@/components/form/text-input';
import NoneChip from '@/components/chip/none-chip';
import ConnectorStepCard from './connector-step-card';
import ButtonProxyFileDownload from './proxy/button-proxy-file-download';

interface Props {
  id: string;
  name: string;
  serviceUrl: string;
  catalogUrl?: string;
}

const ProxyDeploymentCard: FC<Props> = ({ id, serviceUrl, catalogUrl, name }) => (
  <ConnectorStepCard title="Deployment">
    <Stack gap={2}>
      <Text bold>PAC File URL</Text>
      {serviceUrl ? (
        <TextInput
          name="serviceUrl"
          disabled
          copyClip
          value={serviceUrl}
          fullWidth
          size="x-small"
        />
      ) : (
        <NoneChip />
      )}

      <Text bold>Catalog URL</Text>
      {catalogUrl ? (
        <TextInput
          name="catalogUrl"
          disabled
          copyClip
          value={catalogUrl}
          fullWidth
          size="x-small"
        />
      ) : (
        <NoneChip />
      )}

      <Text bold>MDM Files</Text>
      <Text>
        Some mobile device management tools require configuration files to deploy the F5 Workforce
        AI Security integration. This download provides a signed Apple profile for MacOS deployments
        and PowerShell scripts for Windows deployments that is specific to this connector.
      </Text>
      <ButtonProxyFileDownload id={id} name={name} />
    </Stack>
  </ConnectorStepCard>
);

export default ProxyDeploymentCard;
